<template>
  <div>
    <div class="header">
      <Header></Header>
    </div>
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <div class="all" style="background-color: white">
          <el-row>
            <el-col :span="24">
              <div style="background:#dcdfe6;height: 70px;padding-top: 40px;text-align: center;">
                <span style="font-size: 24px">SUBMIT ABSTRACT</span>
              </div>
            </el-col>
          </el-row>
          <el-row justify="center" type="flex" style="margin-top: 50px;margin-bottom: 50px">
            <el-form ref="upLoadForm" :model="upLoadForm" :rules="upLoadFormRules" label-width="120px" style="width: 65%;">
              <el-form-item label="Title" prop="thesisTitle">
                <el-input v-model="upLoadForm.thesisTitle"></el-input>
              </el-form-item>
<!--              <el-form-item label="论文主题" prop="thesisTopic">-->
<!--                <el-input v-model="upLoadForm.thesisTopic"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="论文摘要">-->
<!--                <el-input v-model="upLoadForm.thesisAbstract"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="Keywords" prop="keyWord">
                <el-input v-model="upLoadForm.keyWord"></el-input>
              </el-form-item>
<!--              <el-form-item label="投稿分会场" prop="subConfId">-->
<!--                <el-select v-model="upLoadForm.subConfId" placeholder="请选择投稿分会场">-->
<!--                  <el-option-->
<!--                      v-for="item in options"-->
<!--                      :key="item.subConfId"-->
<!--                      :label="item.subConfName"-->
<!--                      :value="item.subConfId">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item label="thesis Type" prop="thesisType">
                <el-radio-group style="margin-left: 15px" v-model="upLoadForm.thesisType">
                  <el-radio :label="0">oral presentation</el-radio>
                  <el-radio :label="1">poster presentation</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="First Author" prop="firstAuthor">
                <el-input v-model="upLoadForm.firstAuthor"></el-input>
              </el-form-item>
              <el-form-item label="Corresponding Author" prop="corAuthor">
                <el-input v-model="upLoadForm.corAuthor"></el-input>
              </el-form-item>
              <el-form-item label="Presenting Author">
                <el-input v-model="upLoadForm.preAuthor"></el-input>
              </el-form-item>
              <el-form-item label="affiliation" prop="unitName">
                <el-input v-model="upLoadForm.unitName"></el-input>
              </el-form-item>
<!--              <el-form-item label="联系电话" prop="phonenumber">-->
<!--                <el-input v-model="upLoadForm.phonenumber"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="Email" prop="email">
                <el-input v-model="upLoadForm.email"></el-input>
              </el-form-item>
<!--              <el-form-item label="稿件说明标题">-->
<!--                <el-input v-model="upLoadForm.thesisFileTitle"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="稿件说明">-->
<!--                <el-input type="textarea" v-model="upLoadForm.thesisFileDescription"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="City" prop="city">
                <el-input v-model="upLoadForm.city"></el-input>
              </el-form-item>
              <el-form-item label="Country" prop="country">
                <el-input v-model="upLoadForm.country"></el-input>
              </el-form-item>
              <el-form-item label="Requirements for Attachment">
                <p style="color: red" v-html="notice"></p>
              </el-form-item>
              <el-form-item label="Abstract Template">
                <template>
                  <el-upload
                      v-if="fileList2.length !== 0"
                      style="line-height: 0;margin-top: -14px;font-size: 20px"
                      disabled
                      action="#"
                      :before-remove="beforeRemove2"
                      :on-preview="downLoad"
                      :file-list="fileList2">
                  </el-upload>
                  <span v-else style="color: red;margin-left: 10px">null</span>
                </template>
              </el-form-item>
              <el-form-item label="Upload" prop="confThesisFileList">
                <template>
                  <div class="el-upload__tip" slot="tip" style="color: red">Files should be in DOC or DOCx format, no more than 20MB in size, and no more than one file can be uploaded</div>
                  <el-upload
                          style="margin-top: 85px;"
                      ref="upload"
                      drag
                      action="#"
                      :limit="1"
                      multiple
                      show-file-list
                      :http-request="upload"
                      accept=".docx,.doc"
                      :on-change="handleChange"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :on-remove="handleRemove"
                      :before-upload="beforeUpload"
                      :before-remove="beforeRemove"
                  >
                    <div  class="el-upload__tip" slot="tip" style="color: red;position: absolute;top: 0;font-size: 16px">Files should be in DOC or DOCx format, no more than 20MB in size, and no more than one file can be uploaded.</div>
                    <i style="margin-top: 20px;" class="el-icon-upload">

                    </i>
                    <div class="el-upload__text">Drag the file here，or<em>Click to upload</em></div>
                  </el-upload>
                </template>
              </el-form-item>
              <el-form-item>
                <p>tip：After submitting the paper, you can go to the personal center to view it!</p>
              </el-form-item>
              <el-form-item>
                <el-button style="margin-left: 35%;margin-top: 50px" v-preventReClick type="primary" @click="onSave">submit</el-button>
                <el-button @click="close">close</el-button>
              </el-form-item>
            </el-form>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "signUpLoad",
  data(){
    var chekEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
      if (value === '') {
        callback(new Error('please enter the email'));
      } else {
        if (regEmail.test(value)) {
          // 合法的邮箱
          callback()
        } else {
          callback(new Error('please enter a valid email'))
        }

      }
    }
    var checkPhone= (rule, value, callback) =>{
      const regPhone = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (!value) {
        callback(new Error('please enter the phone number'));
      }else {
        if (regPhone.test(value)) {
          callback()
        } else {
          callback(new Error('please enter the a valid phone number'))
        }
      }
    };
    return{
      loading:'',
      upLoadForm:{
        confId:'',
        thesisTitle:'',
        thesisTopic:'',
        thesisAbstract:'',
        keyWord:'',
        subConfId:'',
        thesisType:0,
        firstAuthor:'',
        corAuthor:'',
        preAuthor:'',
        unitName:'',
        phonenumber:'',
        email:'',
        thesisFileTitle:'',
        thesisFileDescription:'',
        confThesisFileList:[],
        city:'',
        country:'',
      },
      fileList: [],
      fileList2: [],
      notice:'',
      upLoadFormRules: {
        phonenumber: [
          { required:true,validator: checkPhone,trigger: 'blur'}
        ],
        email: [
          { required: true, message: 'please enter the email', trigger: 'blur' },
          { validator: chekEmail,trigger: 'blur'}
        ],
        thesisTitle: [
          { required: true, message: 'please enter the title', trigger: 'blur' },
        ],
        thesisTopic: [
          { required: true, message: 'please enter the thesis topic', trigger: 'blur' },
        ],
        firstAuthor: [
          { required: true, message: 'please enter the first author', trigger: 'blur' },
        ],
        keyWord: [
          { required: true, message: 'please enter the keywords', trigger: 'blur' },
        ],
        subConfId: [
          { required: true, message: '请选择投稿分会场', trigger: 'blur' },
        ],
        thesisType: [
          { required: true, message: 'Select the type of document to submit', trigger: 'blur' },
        ],
        unitName: [
          { required: true, message: 'please enter the affiliation', trigger: 'blur' },
        ],
        corAuthor: [
          { required: true, message: 'Please enter corresponding author', trigger: 'blur' },
        ],
        city: [
          { required: true, message: 'A city cannot be empty', trigger: 'blur' },
        ],
        country: [
          { required: true, message: 'A country cannot be empty', trigger: 'blur' },
        ],
        confThesisFileList: [
          { required: true, message: 'The uploaded file cannot be empty', trigger: 'blur' },
        ],
      },
      options:[],
    }
  },
  methods:{
    beforeRemove2(){
      return false
    },
    //下载
    downLoad(file) {
      this.openFullScreen2()
      const a = document.createElement('a')
      let url = 'https://member.nfsoc.org.cn:8666' + file.url // 若是不完整的url则需要拼接baseURL
      // const url = file.url // 完整的url则直接使用
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        // console.log(a.href)
        a.download = file.name // 下载文件的名字
        // a.download = url.split('/')[url.split('/').length -1] //
        document.body.appendChild(a)
        a.click()
        this.loading.close();
      })
    },


    //删除论文之前
    beforeRemove(){
      return this.$confirm('Are you sure to delete the file?', 'tip', {
        confirmButtonText: 'yes',
        cancelButtonText: 'no',
        type: 'warning'
      }).then(async() => {
        return this.$message.success('have deleted')
      }).catch(() => {
        return reject(false);
      });
    },
    //上传文件超出个数
    handleExceed(){
      return this.$message.error('A maximum of one file can be uploaded')
    },
    //加载
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: 'uploading the file',
        spinner: 'el-icon-loading',
        background: 'rgba(0.7)'
      });

    },
    //下载中
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: 'downloading the file',
        spinner: 'el-icon-loading',
        background: 'rgba(0.7)'
      });

    },
    //上传所有信息
    async upLoadAll(){
      this.openFullScreen()
      const { data: res } = await this.$http.post('api/conference/thesis/user',this.upLoadForm)
      // console.log(res);
      if(res.code === 200){
        this.$message.success('submit success')
        let routeData = this.$router.resolve({ path: '/signup',query:{id:this.upLoadForm.confId}
        });
        window.open(routeData.href, '_self');
        this.loading.close();
      }else{
        return this.$message.error(res.msg)
      }
    },
    onSave() {
      this.$refs['upLoadForm'].validate(valid => {
        if(!valid) {
          return this.$message.error('The information is incomplete')
        }
        if(this.fileList.length === 0) {
          return this.$message.error('Please upload the file')
        }
        if(this.upLoadForm.confThesisFileList.length !== this.fileList.length) {
          return this.$message.error('Please wait until the file is uploaded')
        }
        this.upLoadAll()
      })
    },
    async upload(info){
      const { file } = info
      this.file = file
      let formData = new FormData()
      formData.append('file', file)
      this.$message.success('uploading the file, please wait!')
      this.openFullScreen()
      const { data: res } = await this.$http.post('api/conference/thesis/uploadThesisFile',formData)
      // console.log(res);
      if(res.code === 200){
        var obj={
          thesisFileId:res.thesisFileId,
          thesisFileName: res.thesisFileName,
          thesisFilePath: res.thesisFilePath
        };
        this.upLoadForm.confThesisFileList.push(obj)
        this.loading.close();
        this.$message.success(res.thesisFileName+':uploaded success')
      }else{
        return this.$message.error(res.thesisFileName+':'+res.msg)
      }
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["doc", "docx"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error('The uploaded file must be DOC or DOCx format only');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (!isLt10M) {
        this.$message.error('The size of the uploaded file cannot exceed 20MB');
        return false;
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    //移除文件
    handleRemove(file){
      for(let i=0;i<this.upLoadForm.confThesisFileList.length;i++){
        if(this.upLoadForm.confThesisFileList[i].thesisFileName === file.name){
          this.upLoadForm.confThesisFileList.splice(i, 1)
        }
        if(this.fileList[i].name === file.name){
          this.fileList.splice(i, 1)
        }
      }
    },
    //获取分会场
    async getSubList(){
      const { data: res } = await this.$http.get('api/conference/ConfSubDetailed/allList/'+this.upLoadForm.confId)
      this.options = res.data
    },
    //获取征文需求
    async getRequirment(){
      const { data: res } = await this.$http.get('api/conference/thesisRequirement/'+this.upLoadForm.confId)
      // console.log(res);
      this.notice = res.data.requirementDescription
      this.fileList2 =[]
      const listItem = {};
      listItem.name = res.data.templateName;
      listItem.url = res.data.templatePath;
      this.fileList2.push(listItem)
    },

    close(){
      window.open("about:blank", "_top").close()
    }
  },
  created() {
    this.upLoadForm.confId = this.$route.query.id
    // this.getSubList()
    this.getRequirment()
  }
}
</script>

<style scoped lang="less">
.page{
  background-color: #f2f2f2;
}
.title{
  /*height: ;*/
  font-size: 18px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 10px;
  color: #1da7fe;
  border-left: solid 6px #1da7fe !important;
  border-right: solid 3px #1da7fe !important;
  background-color: #fbfbfb;
}
/deep/ p {
  margin-top: 0;
  margin-bottom: 10px;
}

</style>
